import { FC, useContext } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../../../../app/modules/auth";
import { Languages } from "./Languages";
import { useIntl } from "react-intl";
import { ProfileImageContext } from "../../../helpers/ProfileImageContext";
import clsx from "clsx";
import { useStyleContext } from "../../../helpers/StyleContext";
import { ThemeModeSwitcherMenu } from "./ThemeModeSwitcherMenu";

// import ProfileImage from "../../../helpers/ProfileImage";

const HeaderUserMenu: FC = () => {
  const intl = useIntl();
  const { currentUser, logout } = useAuth();
  const { profileImageState } = useContext(ProfileImageContext);
  const { styleState } = useStyleContext();

  return (
    <div
      className={clsx(
        "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-state-bg fw-bold py-4 fs-6 w-275px",
        {
          "menu-gray-600 menu-state-primary":
            !styleState.toolbar_background_color,
        }
      )}
      data-kt-menu="true"
      style={{
        backgroundColor: styleState?.toolbar_background_color,
        color: styleState?.toolbar_text_color,
      }}
    >
      <div className="menu-item px-3">
        <div className="menu-content d-flex align-items-center px-3">
          <div className="symbol symbol-50px me-5">
            <img
              src={profileImageState.profile_image}
              alt="profile_image"
              style={{
                border: `3px solid ${
                  profileImageState?.braceletColor
                    ? profileImageState?.braceletColor
                    : "not defined"
                }`,
                width: "4em",
                height: "4em",
                borderRadius: "4em",
              }}
            />
          </div>

          <div className="d-flex flex-column">
            <div className="fw-bolder d-flex align-items-center fs-5">
              {currentUser?.first_name}
              <span className="badge badge-light-success fw-bolder fs-8 px-2 py-1 ms-2">
                {intl.formatMessage({
                  id: "MENU.HEADER.USERMENU.STATUS",
                })}
              </span>
            </div>
            <p
              // className="fw-bold text-muted text-hover-primary fs-7"
              className={clsx("fw-bold text-hover-primary fs-7", {
                "text-muted": !styleState.toolbar_text_color,
              })}
              style={{ color: styleState?.toolbar_text_color }}
            >
              {currentUser?.email}
            </p>
          </div>
        </div>
      </div>

      <div className="menu-item px-5">
        <Link
          to="/profile"
          className={clsx("menu-link px-5", {
            "text-hover-primary": styleState.toolbar_text_color,
          })}
          style={{ color: styleState?.toolbar_text_color }}
        >
          {intl.formatMessage({
            id: "MENU.HEADER.USERMENU.MYPROFILE",
          })}
        </Link>
      </div>

      <Languages />

      <div className="menu-item px-5 my-1">
        <Link
          to="/profile"
          className={clsx("menu-link px-5 my-1", {
            "text-hover-primary": styleState.toolbar_text_color,
          })}
          style={{ color: styleState?.toolbar_text_color }}
        >
          {intl.formatMessage({
            id: "MENU.HEADER.USERMENU.ACCOUNTMANAGEMENT",
          })}
        </Link>
      </div>

      <ThemeModeSwitcherMenu />

      <div className="menu-item px-5">
        <p
          onClick={logout}
          className={clsx("menu-link px-5 my-1", {
            "text-hover-primary": styleState.toolbar_text_color,
          })}
          style={{ color: styleState?.toolbar_text_color }}
        >
          {intl.formatMessage({
            id: "MENU.HEADER.USERMENU.EXIT",
          })}
        </p>
      </div>
    </div>
  );
};

export { HeaderUserMenu };
